import http from "./http";
import Service from "../Service";

/**
 * @type OrderService
 */
export default class OrderService extends Service {
    exportTxt(params) {
        return http.get("clients/orders/export-txt", {
            headers: this.getHeaders(),
            params,
            responseType: "blob",
        });
    }

    query(params = {}, config = {}) {
        return http.get("clients/orders/query",
            {
                headers: this.getHeaders(),
                params,
                ...config,
            }
        )
    }

    summary(params = {}) {
        return http.get("clients/orders/summary",
            {
                headers: this.getHeaders(),
                params,
            }
        )
    }

    sellers() {
        return http.get("clients/orders/sellers", {
            headers: this.getHeaders(),
        })
    }

    cancel(orderId, motivoId = null) {
        return http.delete(`clients/orders/${orderId}`, {
            headers: this.getHeaders(),
            data: { motivo_id: motivoId },
        })
    }

    // Síncrono: cancela cada pedido em série dentro desta mesma request e
    // retorna { cancelled, failed } com o resultado real, não uma confirmação
    // de enfileiramento.
    cancelMany(orderIds, motivoId = null) {
        return http.post("clients/orders/cancel",
            { order_ids: orderIds, motivo_id: motivoId },
            { headers: this.getHeaders() }
        )
    }

    // Síncrono, mesmo padrão de cancelMany: reenvia a notificação de "novo
    // pedido" (WhatsApp + e-mail + push) de cada pedido em série, dentro
    // desta mesma request, e retorna { notified, failed }.
    notifyMany(orderIds) {
        return http.post("clients/orders/notify",
            { order_ids: orderIds },
            { headers: this.getHeaders() }
        )
    }

    export_pdf(idPedidoList, collapsePages = false) {
        return http.get("clients/orders/query", {
            headers: this.getHeaders(),
            timeout: 600000,
            params: {
                "filter[idPedido]": idPedidoList.join(","),
                export: "pdf",
                collapse_pages: collapsePages ? 1 : 0,
            },
            responseType: "blob",
        });
    }
}
